import { Contract, Coin, TxnStdFee } from "./contract";
import { SecretNetworkClient } from "secretjs";

export type ExecuteAnswer = {
  deposit: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  redeem: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  transfer: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  send: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  batch_transfer: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  batch_send: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  burn: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  register_receive: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  create_viewing_key: {
    key: ViewingKeyObj;
    [k: string]: unknown;
  };
} | {
  set_viewing_key: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  increase_allowance: {
    allowance: Uint128;
    owner: Addr;
    spender: Addr;
    [k: string]: unknown;
  };
} | {
  decrease_allowance: {
    allowance: Uint128;
    owner: Addr;
    spender: Addr;
    [k: string]: unknown;
  };
} | {
  transfer_from: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  send_from: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  batch_transfer_from: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  batch_send_from: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  burn_from: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  batch_burn_from: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  mint: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  batch_mint: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  add_minters: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  remove_minters: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  set_minters: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  change_admin: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  set_contract_status: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
} | {
  revoke_permit: {
    status: ResponseStatus;
    [k: string]: unknown;
  };
};
export type ResponseStatus = "success" | "failure";
export type ViewingKeyObj = string;
export type Uint128 = string;
export type Addr = string;
export type ExecuteMsg = {
  redeem: {
    amount: Uint128;
    denom?: string | null;
    padding?: string | null;
    [k: string]: unknown;
  };
} | {
  deposit: {
    padding?: string | null;
    [k: string]: unknown;
  };
} | {
  transfer: {
    amount: Uint128;
    memo?: string | null;
    padding?: string | null;
    recipient: string;
    [k: string]: unknown;
  };
} | {
  send: {
    amount: Uint128;
    memo?: string | null;
    msg?: Binary | null;
    padding?: string | null;
    recipient: string;
    recipient_code_hash?: string | null;
    [k: string]: unknown;
  };
} | {
  batch_transfer: {
    actions: TransferAction[];
    padding?: string | null;
    [k: string]: unknown;
  };
} | {
  batch_send: {
    actions: SendAction[];
    padding?: string | null;
    [k: string]: unknown;
  };
} | {
  burn: {
    amount: Uint128;
    memo?: string | null;
    padding?: string | null;
    [k: string]: unknown;
  };
} | {
  register_receive: {
    code_hash: string;
    padding?: string | null;
    [k: string]: unknown;
  };
} | {
  create_viewing_key: {
    entropy: string;
    padding?: string | null;
    [k: string]: unknown;
  };
} | {
  set_viewing_key: {
    key: string;
    padding?: string | null;
    [k: string]: unknown;
  };
} | {
  increase_allowance: {
    amount: Uint128;
    expiration?: number | null;
    padding?: string | null;
    spender: string;
    [k: string]: unknown;
  };
} | {
  decrease_allowance: {
    amount: Uint128;
    expiration?: number | null;
    padding?: string | null;
    spender: string;
    [k: string]: unknown;
  };
} | {
  transfer_from: {
    amount: Uint128;
    memo?: string | null;
    owner: string;
    padding?: string | null;
    recipient: string;
    [k: string]: unknown;
  };
} | {
  send_from: {
    amount: Uint128;
    memo?: string | null;
    msg?: Binary | null;
    owner: string;
    padding?: string | null;
    recipient: string;
    recipient_code_hash?: string | null;
    [k: string]: unknown;
  };
} | {
  batch_transfer_from: {
    actions: TransferFromAction[];
    padding?: string | null;
    [k: string]: unknown;
  };
} | {
  batch_send_from: {
    actions: SendFromAction[];
    padding?: string | null;
    [k: string]: unknown;
  };
} | {
  burn_from: {
    amount: Uint128;
    memo?: string | null;
    owner: string;
    padding?: string | null;
    [k: string]: unknown;
  };
} | {
  batch_burn_from: {
    actions: BurnFromAction[];
    padding?: string | null;
    [k: string]: unknown;
  };
} | {
  mint: {
    amount: Uint128;
    memo?: string | null;
    padding?: string | null;
    recipient: string;
    [k: string]: unknown;
  };
} | {
  batch_mint: {
    actions: MintAction[];
    padding?: string | null;
    [k: string]: unknown;
  };
} | {
  add_minters: {
    minters: string[];
    padding?: string | null;
    [k: string]: unknown;
  };
} | {
  remove_minters: {
    minters: string[];
    padding?: string | null;
    [k: string]: unknown;
  };
} | {
  set_minters: {
    minters: string[];
    padding?: string | null;
    [k: string]: unknown;
  };
} | {
  change_admin: {
    address: string;
    padding?: string | null;
    [k: string]: unknown;
  };
} | {
  set_contract_status: {
    level: ContractStatusLevel;
    padding?: string | null;
    [k: string]: unknown;
  };
} | {
  revoke_permit: {
    padding?: string | null;
    permit_name: string;
    [k: string]: unknown;
  };
};
export type Binary = string;
export type ContractStatusLevel = "normal_run" | "stop_all_but_redeems" | "stop_all";
export interface TransferAction {
  amount: Uint128;
  memo?: string | null;
  recipient: Addr;
  [k: string]: unknown;
}
export interface SendAction {
  amount: Uint128;
  memo?: string | null;
  msg?: Binary | null;
  recipient: Addr;
  recipient_code_hash?: string | null;
  [k: string]: unknown;
}
export interface TransferFromAction {
  amount: Uint128;
  memo?: string | null;
  owner: string;
  recipient: string;
  [k: string]: unknown;
}
export interface SendFromAction {
  amount: Uint128;
  memo?: string | null;
  msg?: Binary | null;
  owner: string;
  recipient: string;
  recipient_code_hash?: string | null;
  [k: string]: unknown;
}
export interface BurnFromAction {
  amount: Uint128;
  memo?: string | null;
  owner: string;
  [k: string]: unknown;
}
export interface MintAction {
  amount: Uint128;
  memo?: string | null;
  recipient: string;
  [k: string]: unknown;
}
export interface InstantiateMsg {
  admin?: string | null;
  config?: InitConfig | null;
  decimals: number;
  init_hook?: InitHook | null;
  initial_balances?: InitialBalance[] | null;
  name: string;
  prng_seed: Binary;
  symbol: string;
  [k: string]: unknown;
}
export interface InitConfig {
  enable_burn?: boolean | null;
  enable_deposit?: boolean | null;
  enable_mint?: boolean | null;
  enable_redeem?: boolean | null;
  public_total_supply?: boolean | null;
  [k: string]: unknown;
}
export interface InitHook {
  code_hash: string;
  contract_addr: Addr;
  msg: Binary;
  [k: string]: unknown;
}
export interface InitialBalance {
  address: string;
  amount: Uint128;
  [k: string]: unknown;
}
export type QueryAnswer = {
  token_info: {
    decimals: number;
    name: string;
    symbol: string;
    total_supply?: Uint128 | null;
    [k: string]: unknown;
  };
} | {
  token_config: {
    burn_enabled: boolean;
    deposit_enabled: boolean;
    mint_enabled: boolean;
    public_total_supply: boolean;
    redeem_enabled: boolean;
    [k: string]: unknown;
  };
} | {
  contract_status: {
    status: ContractStatusLevel;
    [k: string]: unknown;
  };
} | {
  exchange_rate: {
    denom: string;
    rate: Uint128;
    [k: string]: unknown;
  };
} | {
  allowance: {
    allowance: Uint128;
    expiration?: number | null;
    owner: Addr;
    spender: Addr;
    [k: string]: unknown;
  };
} | {
  balance: {
    amount: Uint128;
    [k: string]: unknown;
  };
} | {
  transfer_history: {
    total?: number | null;
    txs: Tx[];
    [k: string]: unknown;
  };
} | {
  transaction_history: {
    total?: number | null;
    txs: ExtendedTx[];
    [k: string]: unknown;
  };
} | {
  viewing_key_error: {
    msg: string;
    [k: string]: unknown;
  };
} | {
  minters: {
    minters: Addr[];
    [k: string]: unknown;
  };
};
export type TxAction = {
  transfer: {
    from: Addr;
    recipient: Addr;
    sender: Addr;
    [k: string]: unknown;
  };
} | {
  mint: {
    minter: Addr;
    recipient: Addr;
    [k: string]: unknown;
  };
} | {
  burn: {
    burner: Addr;
    owner: Addr;
    [k: string]: unknown;
  };
} | {
  deposit: {
    [k: string]: unknown;
  };
} | {
  redeem: {
    [k: string]: unknown;
  };
};
export interface Tx {
  block_height?: number | null;
  block_time?: number | null;
  coins: Coin;
  from: Addr;
  id: number;
  memo?: string | null;
  receiver: Addr;
  sender: Addr;
  [k: string]: unknown;
}
export interface ExtendedTx {
  action: TxAction;
  block_height: number;
  block_time: number;
  coins: Coin;
  id: number;
  memo?: string | null;
  [k: string]: unknown;
}
export type QueryMsg = {
  token_info: {
    [k: string]: unknown;
  };
} | {
  token_config: {
    [k: string]: unknown;
  };
} | {
  contract_status: {
    [k: string]: unknown;
  };
} | {
  exchange_rate: {
    [k: string]: unknown;
  };
} | {
  allowance: {
    key: string;
    owner: string;
    spender: string;
    [k: string]: unknown;
  };
} | {
  balance: {
    address: string;
    key: string;
    [k: string]: unknown;
  };
} | {
  transfer_history: {
    address: string;
    key: string;
    page?: number | null;
    page_size: number;
    [k: string]: unknown;
  };
} | {
  transaction_history: {
    address: string;
    key: string;
    page?: number | null;
    page_size: number;
    [k: string]: unknown;
  };
} | {
  minters: {
    [k: string]: unknown;
  };
} | {
  with_permit: {
    permit: Permit_for_TokenPermissions;
    query: QueryWithPermit;
    [k: string]: unknown;
  };
};
export type TokenPermissions = "allowance" | "balance" | "history" | "owner";
export type QueryWithPermit = {
  allowance: {
    owner: string;
    spender: string;
    [k: string]: unknown;
  };
} | {
  balance: {
    [k: string]: unknown;
  };
} | {
  transfer_history: {
    page?: number | null;
    page_size: number;
    [k: string]: unknown;
  };
} | {
  transaction_history: {
    page?: number | null;
    page_size: number;
    [k: string]: unknown;
  };
};
export interface Permit_for_TokenPermissions {
  params: PermitParams_for_TokenPermissions;
  signature: PermitSignature;
  [k: string]: unknown;
}
export interface PermitParams_for_TokenPermissions {
  allowed_tokens: string[];
  chain_id: string;
  permissions: TokenPermissions[];
  permit_name: string;
  [k: string]: unknown;
}
export interface PermitSignature {
  pub_key: PubKey;
  signature: Binary;
  [k: string]: unknown;
}
export interface PubKey {
  type: string;
  value: Binary;
  [k: string]: unknown;
}
export interface Snip20ReferenceImplReadOnlyInterface {
  tokenInfo: () => Promise<any>;
  tokenConfig: () => Promise<any>;
  contractStatus: () => Promise<any>;
  exchangeRate: () => Promise<any>;
  allowance: ({
    key,
    owner,
    spender
  }: {
    key: string;
    owner: string;
    spender: string;
  }) => Promise<any>;
  balance: ({
    address,
    key
  }: {
    address: string;
    key: string;
  }) => Promise<any>;
  transferHistory: ({
    address,
    key,
    page,
    pageSize
  }: {
    address: string;
    key: string;
    page?: number;
    pageSize: number;
  }) => Promise<any>;
  transactionHistory: ({
    address,
    key,
    page,
    pageSize
  }: {
    address: string;
    key: string;
    page?: number;
    pageSize: number;
  }) => Promise<any>;
  minters: () => Promise<any>;
  withPermit: ({
    permit,
    query
  }: {
    permit: Permit_for_TokenPermissions;
    query: QueryWithPermit;
  }) => Promise<any>;
}
export class Snip20ReferenceImplQueryContract extends Contract implements Snip20ReferenceImplReadOnlyInterface {
  constructor(client: SecretNetworkClient, contractAddress: string, contractHash?: string) {
    super(client, contractAddress, contractHash);
    this.tokenInfo = this.tokenInfo.bind(this);
    this.tokenConfig = this.tokenConfig.bind(this);
    this.contractStatus = this.contractStatus.bind(this);
    this.exchangeRate = this.exchangeRate.bind(this);
    this.allowance = this.allowance.bind(this);
    this.balance = this.balance.bind(this);
    this.transferHistory = this.transferHistory.bind(this);
    this.transactionHistory = this.transactionHistory.bind(this);
    this.minters = this.minters.bind(this);
    this.withPermit = this.withPermit.bind(this);
  }
  tokenInfo = async (): Promise<any> => {
    return this.queryMsg({
      token_info: {}
    });
  };
  tokenConfig = async (): Promise<any> => {
    return this.queryMsg({
      token_config: {}
    });
  };
  contractStatus = async (): Promise<any> => {
    return this.queryMsg({
      contract_status: {}
    });
  };
  exchangeRate = async (): Promise<any> => {
    return this.queryMsg({
      exchange_rate: {}
    });
  };
  allowance = async ({
    key,
    owner,
    spender
  }: {
    key: string;
    owner: string;
    spender: string;
  }): Promise<any> => {
    return this.queryMsg({
      allowance: {
        key,
        owner,
        spender
      }
    });
  };
  balance = async ({
    address,
    key
  }: {
    address: string;
    key: string;
  }): Promise<any> => {
    return this.queryMsg({
      balance: {
        address,
        key
      }
    });
  };
  transferHistory = async ({
    address,
    key,
    page,
    pageSize
  }: {
    address: string;
    key: string;
    page?: number;
    pageSize: number;
  }): Promise<any> => {
    return this.queryMsg({
      transfer_history: {
        address,
        key,
        page,
        page_size: pageSize
      }
    });
  };
  transactionHistory = async ({
    address,
    key,
    page,
    pageSize
  }: {
    address: string;
    key: string;
    page?: number;
    pageSize: number;
  }): Promise<any> => {
    return this.queryMsg({
      transaction_history: {
        address,
        key,
        page,
        page_size: pageSize
      }
    });
  };
  minters = async (): Promise<any> => {
    return this.queryMsg({
      minters: {}
    });
  };
  withPermit = async ({
    permit,
    query
  }: {
    permit: Permit_for_TokenPermissions;
    query: QueryWithPermit;
  }): Promise<any> => {
    return this.queryMsg({
      with_permit: {
        permit,
        query
      }
    });
  };
}
export interface Snip20ReferenceImplInterface extends Snip20ReferenceImplReadOnlyInterface {
  redeem: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    amount,
    denom,
    padding
  }: {
    amount: Uint128;
    denom?: string;
    padding?: string;
  }) => Promise<any>;
  deposit: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    padding
  }: {
    padding?: string;
  }) => Promise<any>;
  transfer: ({
    txnuserAddress,
    txnCustomFees,
    txnMemo,
    txnTransferAmount
  }: {
    txnuserAddress: string;
    txnCustomFees?: TxnStdFee;
    txnMemo?: string;
    txnTransferAmount?: readonly Coin[];
  }, {
    amount,
    memo,
    padding,
    recipient
  }: {
    amount: Uint128;
    memo?: string;
    padding?: string;
    recipient: string;
  }) => Promise<any>;
  send: ({
    txnuserAddress,
    txnCustomFees,
    txnMemo,
    txnTransferAmount
  }: {
    txnuserAddress: string;
    txnCustomFees?: TxnStdFee;
    txnMemo?: string;
    txnTransferAmount?: readonly Coin[];
  }, {
    amount,
    memo,
    msg,
    padding,
    recipient,
    recipientCodeHash
  }: {
    amount: Uint128;
    memo?: string;
    msg?: Binary;
    padding?: string;
    recipient: string;
    recipientCodeHash?: string;
  }) => Promise<any>;
  batchTransfer: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    actions,
    padding
  }: {
    actions: TransferAction[];
    padding?: string;
  }) => Promise<any>;
  batchSend: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    actions,
    padding
  }: {
    actions: SendAction[];
    padding?: string;
  }) => Promise<any>;
  burn: ({
    txnuserAddress,
    txnCustomFees,
    txnMemo,
    txnTransferAmount
  }: {
    txnuserAddress: string;
    txnCustomFees?: TxnStdFee;
    txnMemo?: string;
    txnTransferAmount?: readonly Coin[];
  }, {
    amount,
    memo,
    padding
  }: {
    amount: Uint128;
    memo?: string;
    padding?: string;
  }) => Promise<any>;
  registerReceive: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    codeHash,
    padding
  }: {
    codeHash: string;
    padding?: string;
  }) => Promise<any>;
  createViewingKey: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    entropy,
    padding
  }: {
    entropy: string;
    padding?: string;
  }) => Promise<any>;
  setViewingKey: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    key,
    padding
  }: {
    key: string;
    padding?: string;
  }) => Promise<any>;
  increaseAllowance: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    amount,
    expiration,
    padding,
    spender
  }: {
    amount: Uint128;
    expiration?: number;
    padding?: string;
    spender: string;
  }) => Promise<any>;
  decreaseAllowance: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    amount,
    expiration,
    padding,
    spender
  }: {
    amount: Uint128;
    expiration?: number;
    padding?: string;
    spender: string;
  }) => Promise<any>;
  transferFrom: ({
    txnuserAddress,
    txnCustomFees,
    txnMemo,
    txnTransferAmount
  }: {
    txnuserAddress: string;
    txnCustomFees?: TxnStdFee;
    txnMemo?: string;
    txnTransferAmount?: readonly Coin[];
  }, {
    amount,
    memo,
    owner,
    padding,
    recipient
  }: {
    amount: Uint128;
    memo?: string;
    owner: string;
    padding?: string;
    recipient: string;
  }) => Promise<any>;
  sendFrom: ({
    txnuserAddress,
    txnCustomFees,
    txnMemo,
    txnTransferAmount
  }: {
    txnuserAddress: string;
    txnCustomFees?: TxnStdFee;
    txnMemo?: string;
    txnTransferAmount?: readonly Coin[];
  }, {
    amount,
    memo,
    msg,
    owner,
    padding,
    recipient,
    recipientCodeHash
  }: {
    amount: Uint128;
    memo?: string;
    msg?: Binary;
    owner: string;
    padding?: string;
    recipient: string;
    recipientCodeHash?: string;
  }) => Promise<any>;
  batchTransferFrom: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    actions,
    padding
  }: {
    actions: TransferFromAction[];
    padding?: string;
  }) => Promise<any>;
  batchSendFrom: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    actions,
    padding
  }: {
    actions: SendFromAction[];
    padding?: string;
  }) => Promise<any>;
  burnFrom: ({
    txnuserAddress,
    txnCustomFees,
    txnMemo,
    txnTransferAmount
  }: {
    txnuserAddress: string;
    txnCustomFees?: TxnStdFee;
    txnMemo?: string;
    txnTransferAmount?: readonly Coin[];
  }, {
    amount,
    memo,
    owner,
    padding
  }: {
    amount: Uint128;
    memo?: string;
    owner: string;
    padding?: string;
  }) => Promise<any>;
  batchBurnFrom: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    actions,
    padding
  }: {
    actions: BurnFromAction[];
    padding?: string;
  }) => Promise<any>;
  mint: ({
    txnuserAddress,
    txnCustomFees,
    txnMemo,
    txnTransferAmount
  }: {
    txnuserAddress: string;
    txnCustomFees?: TxnStdFee;
    txnMemo?: string;
    txnTransferAmount?: readonly Coin[];
  }, {
    amount,
    memo,
    padding,
    recipient
  }: {
    amount: Uint128;
    memo?: string;
    padding?: string;
    recipient: string;
  }) => Promise<any>;
  batchMint: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    actions,
    padding
  }: {
    actions: MintAction[];
    padding?: string;
  }) => Promise<any>;
  addMinters: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    minters,
    padding
  }: {
    minters: string[];
    padding?: string;
  }) => Promise<any>;
  removeMinters: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    minters,
    padding
  }: {
    minters: string[];
    padding?: string;
  }) => Promise<any>;
  setMinters: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    minters,
    padding
  }: {
    minters: string[];
    padding?: string;
  }) => Promise<any>;
  changeAdmin: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    address,
    padding
  }: {
    address: string;
    padding?: string;
  }) => Promise<any>;
  setContractStatus: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    level,
    padding
  }: {
    level: ContractStatusLevel;
    padding?: string;
  }) => Promise<any>;
  revokePermit: ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    padding,
    permitName
  }: {
    padding?: string;
    permitName: string;
  }) => Promise<any>;
}
export class Snip20ReferenceImplContract extends Snip20ReferenceImplQueryContract implements Snip20ReferenceImplInterface {
  constructor(client: SecretNetworkClient, contractAddress: string, contractHash?: string) {
    super(client, contractAddress, contractHash);
    this.redeem = this.redeem.bind(this);
    this.deposit = this.deposit.bind(this);
    this.transfer = this.transfer.bind(this);
    this.send = this.send.bind(this);
    this.batchTransfer = this.batchTransfer.bind(this);
    this.batchSend = this.batchSend.bind(this);
    this.burn = this.burn.bind(this);
    this.registerReceive = this.registerReceive.bind(this);
    this.createViewingKey = this.createViewingKey.bind(this);
    this.setViewingKey = this.setViewingKey.bind(this);
    this.increaseAllowance = this.increaseAllowance.bind(this);
    this.decreaseAllowance = this.decreaseAllowance.bind(this);
    this.transferFrom = this.transferFrom.bind(this);
    this.sendFrom = this.sendFrom.bind(this);
    this.batchTransferFrom = this.batchTransferFrom.bind(this);
    this.batchSendFrom = this.batchSendFrom.bind(this);
    this.burnFrom = this.burnFrom.bind(this);
    this.batchBurnFrom = this.batchBurnFrom.bind(this);
    this.mint = this.mint.bind(this);
    this.batchMint = this.batchMint.bind(this);
    this.addMinters = this.addMinters.bind(this);
    this.removeMinters = this.removeMinters.bind(this);
    this.setMinters = this.setMinters.bind(this);
    this.changeAdmin = this.changeAdmin.bind(this);
    this.setContractStatus = this.setContractStatus.bind(this);
    this.revokePermit = this.revokePermit.bind(this);
  }
  redeem = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    amount,
    denom,
    padding
  }: {
    amount: Uint128;
    denom?: string;
    padding?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      redeem: {
        amount,
        denom,
        padding
      }
    }, userAddress, customFees, memo, transferAmount);
  };
  deposit = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    padding
  }: {
    padding?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      deposit: {
        padding
      }
    }, userAddress, customFees, memo, transferAmount);
  };
  transfer = async ({
    txnuserAddress,
    txnCustomFees,
    txnMemo,
    txnTransferAmount
  }: {
    txnuserAddress: string;
    txnCustomFees?: TxnStdFee;
    txnMemo?: string;
    txnTransferAmount?: readonly Coin[];
  }, {
    amount,
    memo,
    padding,
    recipient
  }: {
    amount: Uint128;
    memo?: string;
    padding?: string;
    recipient: string;
  }): Promise<any> => {
    return await this.executeMsg({
      transfer: {
        amount,
        memo,
        padding,
        recipient
      }
    }, txnuserAddress, txnCustomFees, txnMemo, txnTransferAmount);
  };
  send = async ({
    txnuserAddress,
    txnCustomFees,
    txnMemo,
    txnTransferAmount
  }: {
    txnuserAddress: string;
    txnCustomFees?: TxnStdFee;
    txnMemo?: string;
    txnTransferAmount?: readonly Coin[];
  }, {
    amount,
    memo,
    msg,
    padding,
    recipient,
    recipientCodeHash
  }: {
    amount: Uint128;
    memo?: string;
    msg?: Binary;
    padding?: string;
    recipient: string;
    recipientCodeHash?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      send: {
        amount,
        memo,
        msg,
        padding,
        recipient,
        recipient_code_hash: recipientCodeHash
      }
    }, txnuserAddress, txnCustomFees, txnMemo, txnTransferAmount);
  };
  batchTransfer = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    actions,
    padding
  }: {
    actions: TransferAction[];
    padding?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      batch_transfer: {
        actions,
        padding
      }
    }, userAddress, customFees, memo, transferAmount);
  };
  batchSend = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    actions,
    padding
  }: {
    actions: SendAction[];
    padding?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      batch_send: {
        actions,
        padding
      }
    }, userAddress, customFees, memo, transferAmount);
  };
  burn = async ({
    txnuserAddress,
    txnCustomFees,
    txnMemo,
    txnTransferAmount
  }: {
    txnuserAddress: string;
    txnCustomFees?: TxnStdFee;
    txnMemo?: string;
    txnTransferAmount?: readonly Coin[];
  }, {
    amount,
    memo,
    padding
  }: {
    amount: Uint128;
    memo?: string;
    padding?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      burn: {
        amount,
        memo,
        padding
      }
    }, txnuserAddress, txnCustomFees, txnMemo, txnTransferAmount);
  };
  registerReceive = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    codeHash,
    padding
  }: {
    codeHash: string;
    padding?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      register_receive: {
        code_hash: codeHash,
        padding
      }
    }, userAddress, customFees, memo, transferAmount);
  };
  createViewingKey = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    entropy,
    padding
  }: {
    entropy: string;
    padding?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      create_viewing_key: {
        entropy,
        padding
      }
    }, userAddress, customFees, memo, transferAmount);
  };
  setViewingKey = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    key,
    padding
  }: {
    key: string;
    padding?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      set_viewing_key: {
        key,
        padding
      }
    }, userAddress, customFees, memo, transferAmount);
  };
  increaseAllowance = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    amount,
    expiration,
    padding,
    spender
  }: {
    amount: Uint128;
    expiration?: number;
    padding?: string;
    spender: string;
  }): Promise<any> => {
    return await this.executeMsg({
      increase_allowance: {
        amount,
        expiration,
        padding,
        spender
      }
    }, userAddress, customFees, memo, transferAmount);
  };
  decreaseAllowance = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    amount,
    expiration,
    padding,
    spender
  }: {
    amount: Uint128;
    expiration?: number;
    padding?: string;
    spender: string;
  }): Promise<any> => {
    return await this.executeMsg({
      decrease_allowance: {
        amount,
        expiration,
        padding,
        spender
      }
    }, userAddress, customFees, memo, transferAmount);
  };
  transferFrom = async ({
    txnuserAddress,
    txnCustomFees,
    txnMemo,
    txnTransferAmount
  }: {
    txnuserAddress: string;
    txnCustomFees?: TxnStdFee;
    txnMemo?: string;
    txnTransferAmount?: readonly Coin[];
  }, {
    amount,
    memo,
    owner,
    padding,
    recipient
  }: {
    amount: Uint128;
    memo?: string;
    owner: string;
    padding?: string;
    recipient: string;
  }): Promise<any> => {
    return await this.executeMsg({
      transfer_from: {
        amount,
        memo,
        owner,
        padding,
        recipient
      }
    }, txnuserAddress, txnCustomFees, txnMemo, txnTransferAmount);
  };
  sendFrom = async ({
    txnuserAddress,
    txnCustomFees,
    txnMemo,
    txnTransferAmount
  }: {
    txnuserAddress: string;
    txnCustomFees?: TxnStdFee;
    txnMemo?: string;
    txnTransferAmount?: readonly Coin[];
  }, {
    amount,
    memo,
    msg,
    owner,
    padding,
    recipient,
    recipientCodeHash
  }: {
    amount: Uint128;
    memo?: string;
    msg?: Binary;
    owner: string;
    padding?: string;
    recipient: string;
    recipientCodeHash?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      send_from: {
        amount,
        memo,
        msg,
        owner,
        padding,
        recipient,
        recipient_code_hash: recipientCodeHash
      }
    }, txnuserAddress, txnCustomFees, txnMemo, txnTransferAmount);
  };
  batchTransferFrom = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    actions,
    padding
  }: {
    actions: TransferFromAction[];
    padding?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      batch_transfer_from: {
        actions,
        padding
      }
    }, userAddress, customFees, memo, transferAmount);
  };
  batchSendFrom = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    actions,
    padding
  }: {
    actions: SendFromAction[];
    padding?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      batch_send_from: {
        actions,
        padding
      }
    }, userAddress, customFees, memo, transferAmount);
  };
  burnFrom = async ({
    txnuserAddress,
    txnCustomFees,
    txnMemo,
    txnTransferAmount
  }: {
    txnuserAddress: string;
    txnCustomFees?: TxnStdFee;
    txnMemo?: string;
    txnTransferAmount?: readonly Coin[];
  }, {
    amount,
    memo,
    owner,
    padding
  }: {
    amount: Uint128;
    memo?: string;
    owner: string;
    padding?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      burn_from: {
        amount,
        memo,
        owner,
        padding
      }
    }, txnuserAddress, txnCustomFees, txnMemo, txnTransferAmount);
  };
  batchBurnFrom = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    actions,
    padding
  }: {
    actions: BurnFromAction[];
    padding?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      batch_burn_from: {
        actions,
        padding
      }
    }, userAddress, customFees, memo, transferAmount);
  };
  mint = async ({
    txnuserAddress,
    txnCustomFees,
    txnMemo,
    txnTransferAmount
  }: {
    txnuserAddress: string;
    txnCustomFees?: TxnStdFee;
    txnMemo?: string;
    txnTransferAmount?: readonly Coin[];
  }, {
    amount,
    memo,
    padding,
    recipient
  }: {
    amount: Uint128;
    memo?: string;
    padding?: string;
    recipient: string;
  }): Promise<any> => {
    return await this.executeMsg({
      mint: {
        amount,
        memo,
        padding,
        recipient
      }
    }, txnuserAddress, txnCustomFees, txnMemo, txnTransferAmount);
  };
  batchMint = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    actions,
    padding
  }: {
    actions: MintAction[];
    padding?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      batch_mint: {
        actions,
        padding
      }
    }, userAddress, customFees, memo, transferAmount);
  };
  addMinters = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    minters,
    padding
  }: {
    minters: string[];
    padding?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      add_minters: {
        minters,
        padding
      }
    }, userAddress, customFees, memo, transferAmount);
  };
  removeMinters = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    minters,
    padding
  }: {
    minters: string[];
    padding?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      remove_minters: {
        minters,
        padding
      }
    }, userAddress, customFees, memo, transferAmount);
  };
  setMinters = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    minters,
    padding
  }: {
    minters: string[];
    padding?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      set_minters: {
        minters,
        padding
      }
    }, userAddress, customFees, memo, transferAmount);
  };
  changeAdmin = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    address,
    padding
  }: {
    address: string;
    padding?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      change_admin: {
        address,
        padding
      }
    }, userAddress, customFees, memo, transferAmount);
  };
  setContractStatus = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    level,
    padding
  }: {
    level: ContractStatusLevel;
    padding?: string;
  }): Promise<any> => {
    return await this.executeMsg({
      set_contract_status: {
        level,
        padding
      }
    }, userAddress, customFees, memo, transferAmount);
  };
  revokePermit = async ({
    userAddress,
    customFees,
    memo,
    transferAmount
  }: {
    userAddress: string;
    customFees?: TxnStdFee;
    memo?: string;
    transferAmount?: readonly Coin[];
  }, {
    padding,
    permitName
  }: {
    padding?: string;
    permitName: string;
  }): Promise<any> => {
    return await this.executeMsg({
      revoke_permit: {
        padding,
        permit_name: permitName
      }
    }, userAddress, customFees, memo, transferAmount);
  };
}